import React from "react";
import { cn } from "utils/cn";
import BrandLogo from "./BrandLogo";
import { HamburgerButtonContainer } from "./HamburgerButtonContainer";
import SearchWrapper from "./SearchWrapper";
import Galleries from "./Galleries";
import CartButton from "./CartButton";
import loadable from "@loadable/component";
import AccountIcon from "@RHCommerceDev/icon-header-account";

/*
 * AccountNavMenu uses Stytch which is client side, direct import will cause StytchHeadlessClient to throw error
 * so using loadable with `ssr: false` is critical
 */
const AccountNavMenu = loadable(
  () =>
    import(
      /* webpackChunkName: "container-rhr-header/AccountNavMenu" */ "@RHCommerceDev/container-rhr-header/AccountNavMenu"
    ),
  {
    ssr: false,
    fallback: (
      <div
        className={cn(
          "flex items-center justify-center",
          "h-[22px] w-[22px] sm:h-[26px] sm:w-[26px]"
        )}
      >
        <AccountIcon className="h-[16.5px] w-[13.86px]" />
      </div>
    )
  }
);

/* first section of header containing hamburger, search bar, logo , country selector, my account, my cart */
const UtilityBar = () => {
  return (
    <div
      className={cn(
        "flex items-start",
        "h-[82px] sm:h-[102px] md:h-[97px]",
        "px-4 sm:px-8 md:px-10 xl:px-20"
      )}
    >
      {/* section with hamburger and search bar */}
      <div
        className={cn(
          "flex w-full items-center",
          "gap-4 sm:gap-[26px]",
          "mt-[30px] sm:mt-[38px]",
          "h-[22px] sm:h-[26px] "
        )}
      >
        <HamburgerButtonContainer />

        <SearchWrapper />
      </div>

      {/*section with Logo*/}
      <div className="mt-3.5 sm:mt-[23px] lg:mt-[18px]">
        <BrandLogo />
      </div>

      {/*section with galleries, my account , my cart button */}
      <div
        className={cn(
          "flex w-full items-center justify-end",
          "gap-4 sm:gap-[26px]",
          "mt-[30px] sm:mt-[38px]",
          "h-[22px] sm:h-[26px]"
        )}
      >
        <Galleries />
        <AccountNavMenu
          style={{
            color: "inherit"
          }}
        />
        <CartButton />
      </div>
    </div>
  );
};

export default UtilityBar;
